import React, { Fragment } from "react";
import { connect } from "react-redux";
import { LinkContainer } from "react-router-bootstrap";
import UserProfile from "../components/UserProfile";
import EditUserProfile from "../components/EditUserProfile";
import { getUserProfile } from "../actions/userAction";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";

class UserContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.getUserProfile(this.props.match.params.id);
  }
  render() {
    const { loading, uzer } = this.props.uzer;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            className="mt-2"
            id="left-tabs-example"
            defaultActiveKey="profile"
            mountOnEnter
            unmountOnExit
          >
            <Row>
              <Col sm={2} className="pt-5">
                <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                    <Nav.Link eventKey="profile">User Profile</Nav.Link>
                  </Nav.Item>
                  <LinkContainer exact to="/edit_profile/:id">
                    <Nav.Item>
                      <Nav.Link eventKey="edit_profile">
                        Edit User Profile
                      </Nav.Link>
                    </Nav.Item>
                  </LinkContainer>
                </Nav>
              </Col>
              <Col sm={10}>
                <div className="container-fluid">
                  <Tab.Content>
                    <Tab.Pane eventKey="profile">
                      <UserProfile uzer={uzer} />
                    </Tab.Pane>
                    <Tab.Pane eventKey="edit_profile">
                      <EditUserProfile uzer={uzer} />
                    </Tab.Pane>
                  </Tab.Content>
                </div>
              </Col>
            </Row>
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = ({ uzer }) => ({
  uzer: uzer,
});
const mapDispatchToProps = (dispatch) => ({
  getUserProfile: (uzer) => dispatch(getUserProfile(uzer)),
});
export default connect(mapStateToProps, mapDispatchToProps)(UserContainer);
